import { render, staticRenderFns } from "./DeclinedSmsReplyMessages.vue?vue&type=template&id=03328e80&scoped=true&"
import script from "./DeclinedSmsReplyMessages.vue?vue&type=script&lang=js&"
export * from "./DeclinedSmsReplyMessages.vue?vue&type=script&lang=js&"
import style0 from "./DeclinedSmsReplyMessages.vue?vue&type=style&index=0&id=03328e80&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03328e80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VContainer,VPagination,VRow,VSkeletonLoader,VSubheader,VTextField})
